import { useState } from "react";
import { saveCountryDetails } from "../Api/CountryMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const CountryMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

  const [countryData, setCountryData] = useState({
    countryCode: "",
    countryName: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCountryData({
      ...countryData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveCountryDetails(countryData, userId);
      toast.success(`🦄 Country Added Successfully`);
      setCountryData({
        countryCode: "",
        countryName: ""
      });
      navigate("/viewCountry");
    } catch (error) {
      toast.error(`🦄 Error: ${error.message || "Failed to save country details"}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">Country Master</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Country Code <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="countryCode"
                      value={countryData.countryCode}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Country Name <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="countryName"
                      value={countryData.countryName}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save Country
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default CountryMaster;